import React, { useContext, useRef, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import OpenPopupBtn from "../../../common/OpenPopupBtn";
import { Cases, DELETE_CONFIRM, modalsName } from "../../../constant";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import CardBuilderHeaderSection from "../../../common/cardBuilderHeaderSection";
import CommonPopup from "../../../Modals/commonPopup";
import SliderPopup from "./SliderMultipagePopup";
import EditIcon from "@mui/icons-material/Edit";
import SliderParentPopup from "./SliderMultipageParentPopup";
import { FILE_UPLOAD_API, deleteSlider } from "../apis/SliderApi/SliderApi";
import {
  isCheckValue,
  isEmptyObject,
  randomStr,
} from "../../../../utils/helper";
import { FILE_TYPE, ThemeNo, titleUpdateKey } from "../../../../constant";
import { IconButton } from "@material-ui/core";
import { Settings, Trash } from "react-feather";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import SimpleReactValidator from "simple-react-validator";
import SliderMultipageContext from "../../../context/SliderMultipageContext/SliderMultipageContext";
import {
  getSlider,
  getSliderDetails,
  postSlider,
  putUpdateSlider,
  updateStatus,
} from "../apis/SliderApi/SliderApi";
import SettingSliderPerentPopup from "./SettingSliderPerentPopup";
import DeleteSection from "../../../common/DeleteSection";
import SettingMultiWebContext from "../../../../context/SettingMultiWebContext/SettingMultiWebContext";
import {
  NavBarThemeOneFunction,
  NavbarStyleOneSubFun,
  SliderStyleOneReset,
} from "./SliderStyleFunction";
import { uploadFileToSpaces } from "../../../apis/dashboardAPi/DeshboardApi";

const SliderMultipage = (props) => {
  const {
    pageConfigDetails,
    webMasterDetail,
    getData,
    sliderDetail,
    contentMapId,
    ByteMiniWeb_Dashboard,
    contentDetail,
  } = props;
  const { allPopupState, setAllPopupState } = useContext(
    ByteCardBuilderContext
  );
  const { setCloneAlignModal, setAlignFormData, setCloneFormData } = useContext(
    SettingMultiWebContext
  );
  const parentValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const childValidator = useRef(new SimpleReactValidator());
  const {
    fromData,
    setFormData,
    formDataChild,
    setFormDataChild,
    id,
    setId,
    setIsEdit,
    isEdit,
    setFilter,
    apiDataOurTeam: apiDataImageParent,
    setApiDataOurTeam: setApiDataImageParent,
    setSkill,
    setGalleryImgId,
    setSettingFormData,
    settingFormData,
    isParent,
    setIsParent,
    childId,
    setChildId,
    navMapId,
    setNavMapId,
    collId,
    setCollId,
    isBackgroundColor,
    setIsBackgroundColor,
    boxSection,
    setBoxSection,
    theme,
    setTheme,
    imgShow,
    setImgShow,
    sectionPageName,
    setSectionPageName,
  } = useContext(SliderMultipageContext);
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * get slider list
   * @param {status} status
   */
  const getSliderParentList = async ({
    parentId = null,
    isClose = false,
    filter,
  }) => {
    try {
      let paramObj = {
        showAll: true,
      };
      if (
        ((parentId && parentId !== null) ||
          (id && isClose === false && isParent === false)) &&
        isParent === false
      ) {
        paramObj["search"] = { parentId: parentId || id };
        setId(parentId || id);
        if (filter?.length) {
          paramObj["search"] = { ...paramObj.search, title: filter };
        }
      } else {
        paramObj["search"] = { parentId: null };
      }
      const { data } = await getSlider(paramObj);
      if (isCheckValue({ value: parentId })) {
        setChildId(parentId);
      }
      if (data.status === 200) {
        if (
          isParent === false &&
          ((parentId && parentId !== null) || id) &&
          isClose === false
        ) {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.sliderId,
                Id: elem?.sliderId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
          OpenModalCommonFunc(Cases.SLIDER_MULTIPAGE, setAllPopupState);
        } else if (parentId && parentId !== null) {
          OpenModalCommonFunc(Cases.SLIDER_MULTIPAGE, setAllPopupState);
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data.map((elem) => {
              return {
                id: elem?.title + elem?.sliderId,
                Id: elem?.sliderId,
                name: elem?.title,
                image: elem?.image,
                webId: elem?.webId,
                parentId: elem?.parentId,
                createdAt: elem?.createdAt,
                isActive: elem?.isActive,
              };
            }),
          });
        } else {
          setApiDataImageParent({
            ...apiDataImageParent,
            isLoading: false,
            data: data.payload.data,
          });
        }
        if (isClose && isClose !== false) {
          setIsParent(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * slider enable disable api call
   * @param {sliderId} sliderId
   * @param {status} isActive
   */

  const handleChangeSlider = async (sliderId, isActive, isChild, parentId) => {
    // ;
    try {
      let body = {
        sliderId,
        isActive: isActive ? false : true,
        parentId,
      };
      const { data } = await updateStatus(body);
      if (data.status === 200) {
        if (isChild) {
          getSliderParentList({ parentId: id });
        } else {
          ByteMiniWeb_Dashboard();
        }
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * file upload
   * @param {file} file
   */
  const imageUploadImages = async (file) => {
    setLoaderShow(true);
    // let formData = new FormData();
    // formData.append("type", FILE_TYPE.SLIDER);
    // formData.append("file", file);
    const uniqueName = `${Date.now()}-${file.name}`;
    const formData = {
      type: FILE_TYPE.SLIDER,
      file: uniqueName,
      fileType: file.type,
    };
    try {
      const { data } = await FILE_UPLOAD_API(formData);
      if (data.status === 200) {
        if (!data.payload?.uploadUrl) {
          TostMessage({ message: "Failed to get upload URL", type: "error" });
          setLoaderShow(false);
          return;
        }
        await uploadFileToSpaces(data.payload.uploadUrl, file);
        setFormDataChild((prev) => {
          if (formDataChild.imageType === "big") {
            return {
              ...prev,
              bigImage: data.payload.baseUrl + data.payload.imageUrl,
              image: "",
            };
          } else if (formDataChild.imageType === "small") {
            return {
              ...prev,
              mobileSlider: data.payload.baseUrl + data.payload.imageUrl,
              image: "",
            };
          }
        });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * create and update slider
   */
  const submitForm = async () => {
    if (
      (isParent === false && childId >= -1 && isEdit) ||
      (id >= -1 && isEdit)
    ) {
      setLoaderShow(true);
      try {
        let formData = {};
        if (isParent && isParent !== false) {
          formData = { ...fromData, sliderId: id, contentMapId: collId };
          setId("");
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            sliderId: childId,
            contentMapId: collId,
          };

          formData["image"] = formDataChild.bigImage
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
          formData["mobileSlider"] = formDataChild.mobileSlider
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
          delete formData.bigImage;
        }
        const { data } = await putUpdateSlider(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getSliderParentList({ parentId: id });
          }
          emptyData();
          OpenModalCommonFunc(
            Cases.SLIDER_MULTIPAGE_PARENT,
            setAllPopupState,
            false
          );
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    } else {
      try {
        setLoaderShow(true);
        let formData = {};
        if (isParent && isParent !== false) {
          formData = { ...fromData, contentMapId: collId };
        } else {
          formData = {
            ...formDataChild,
            parentId: id,
            navMapId,
            order: apiDataImageParent.data.length + 1,
            contentMapId: collId,
          };
          formData["image"] = formDataChild.bigImage
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
          formData["mobileSlider"] = formDataChild.mobileSlider
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop();
          delete formData.bigImage;
        }
        const { data } = await postSlider(formData);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getSliderParentList({ parentId: id });
          }
          emptyData();
          OpenModalCommonFunc(
            Cases.SLIDER_MULTIPAGE_PARENT,
            setAllPopupState,
            false
          );
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };
  const handleSubmit = async (formValidationCondition) => {
    let validatorFields;
    if (formValidationCondition === "parentForm") {
      validatorFields = parentValidator.current;
    } else if (formValidationCondition === "childForm") {
      validatorFields = childValidator.current;
    }
    validatorFields.showMessages();

    if (validatorFields.allValid()) {
      try {
        // Process form data based on the formType
        if (formValidationCondition === "parentForm") {
          submitForm();
        } else if (formValidationCondition === "childForm") {
          submitForm();
        }
        validatorFields.hideMessages();
      } catch (error) {
        // Handle error for form submission
      }
    } else {
      // Force update to display validation messages
      forceUpdate({});
    }
  };

  /**
   * create and update slider
   */
  const handleSubmitSetting = async (isRestore = false, isClose = true) => {
    if (id >= -1 && isEdit) {
      setLoaderShow(true);
      try {
        let newData;
        if (isRestore) {
          const isConfirm = window.confirm(
            "Are you sure want to restore style ?"
          );
          if (isConfirm) {
            newData = {
              styleRestore: true,
              sliderId: id,
            };
          } else {
            setLoaderShow(false);
            return;
          }
        } else {
          if (+theme === ThemeNo.ThemeOne) {
            newData = NavbarStyleOneSubFun({
              settingFormData,
              boxSection,
              isBackgroundColor,
            });
          }
          const keysToRemove = ["borderPx", "borderThik"];
          function removeKeys(obj, keys) {
            for (const key in obj) {
              if (typeof obj[key] === "object") {
                removeKeys(obj[key], keys);
              } else if (keys.includes(key)) {
                delete obj[key];
              }
            }
          }
          removeKeys(newData, keysToRemove);
          newData = {
            style: newData,
            sliderId: id,
          };
        }

        const { data } = await putUpdateSlider(newData);
        if (data.status === 200) {
          if (isClose) {
            OpenModalCommonFunc(
              Cases.SETTING_SLIDER_PARENT,
              setAllPopupState,
              false
            );
            emptyData();
          }
          setLoaderShow(false);
          TostMessage({ message: data, type: "success" });
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * get data slider
   * @param {id} sliderId
   */
  const handleEditSlider = async (sliderId, isParent) => {
    try {
      setLoaderShow(true);
      const { data } = await getSliderDetails(sliderId);
      if (data.status === 200) {
        let payload = data.payload.data;
        if (isParent) {
          setSectionPageName(payload?.title);
          setId(sliderId);
          setIsParent(true);
          setFormData({
            title: payload?.title || "",
            image: payload?.image || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            navMapId: payload?.navMapId || "",
            webId: localStorage.getItem("webId"),
            style: payload?.style || "",
          });
          OpenModalCommonFunc(Cases.SLIDER_MULTIPAGE_PARENT, setAllPopupState);
        } else {
          setChildId(sliderId);
          setIsParent(false);
          setFormDataChild({
            title: payload?.title || "",
            bigImage: payload?.image || "",
            mobileSlider: payload?.mobileSlider || "",
            description: payload?.description || "",
            isTitleShow: payload?.isTitleShow ? payload?.isTitleShow : false,
            buttonCaption: payload?.buttonCaption || "",
            imageAlt: payload?.imageAlt || "",
            buttonLink: payload?.buttonLink || "",
            parentId: payload?.parentId || "",
            order: payload?.order || 1,
            webId: localStorage.getItem("webId"),
          });
          OpenModalCommonFunc(Cases.SLIDER_MULTIPAGE, setAllPopupState);
        }
        setIsEdit(true);
        TostMessage({ message: data, type: "success" });
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * get setting data
   * @param {id} sliderId
   */
  const handleChangeSettings = async (sliderId, isThemeEdit = false) => {
    try {
      setLoaderShow(true);
      setId(sliderId);
      setSettingFormData((prev) => {
        return {
          ...prev,
          sliderId,
        };
      });
      const { data } = await getSliderDetails(sliderId);
      if (data.status === 200) {
        const themeCount = data?.payload?.data?.theme;
        setTheme(themeCount);
        setImgShow(true);
        let payload = data.payload.data;
        setSectionPageName(payload.title);
        if (
          +themeCount === ThemeNo.ThemeOne &&
          isEmptyObject(data?.payload?.data?.style)
        ) {
          setSettingFormData({ ...SliderStyleOneReset });
          setBoxSection(false);
          setIsBackgroundColor(false);
        } else {
          if (payload.style?.[".top-slider"]?.["background-color"]) {
            setIsBackgroundColor(true);
          }
          if (
            payload.style?.[".top-slider .carousel-item:before"]?.[
            "background-color"
            ]
          ) {
            setBoxSection(true);
          }
          let getStyle;
          if (+themeCount === ThemeNo.ThemeOne) {
            getStyle = NavBarThemeOneFunction(payload);
          } else {
            getStyle = NavBarThemeOneFunction(payload);
          }
          setSettingFormData((prev) => {
            return {
              ...prev,
              ...getStyle,
            };
          });
        }
        if (!isThemeEdit) {
          OpenModalCommonFunc(Cases.SETTING_SLIDER_PARENT, setAllPopupState);
          TostMessage({ message: data, type: "success" });
        }
        setIsEdit(true);
        setLoaderShow(false);
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * delete slider
   * @param {id} sliderId
   */
  const handleDelete = async (sliderId, isParent = false) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteSlider(sliderId);
        if (data.status === 200) {
          if (isParent && isParent !== false) {
            ByteMiniWeb_Dashboard();
          } else {
            getSliderParentList({ packageId: childId });
          }
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * clear data
   */
  const emptyData = () => {
    setIsBackgroundColor(false);
    setIsEdit(false);
    setBoxSection(false);
    setIsParent(false);
    setChildId("");
    setFormData({
      title: "",
      navMapId: "",
      webId: localStorage.getItem("webId"),
      image: "slider",
      isTitleShow: true,
      style: {
        ".top-slider": {
          "background-color": "rgb(255 255 255 / 100)",
        },
        ".top-slider .carousel-item:before": {},
        ".top-slider .slider-content .slide-title": {
          color: "rgb(255 255 255 / 100)",
          "font-size": "40px",
          "font-weight": "600",
          "margin-bottom": "20px",
        },
        ".top-slider .slider-content .slide-desq": {
          color: "rgb(255 255 255 / 100)",
          "font-size": "16px",
          "font-weight": "500",
          "margin-bottom": "20px",
        },
        ".top-slider .slider-content .btn": {
          color: "rgb(255 255 255 / 100)",
          border: "2px solid rgb(255 73 124 / 100)",
          borderColor: "rgb(255 73 124 / 100)",
          "font-size": "16px",
          "font-weight": "600",
          padding: "8px 25px",
          p1: "8px",
          p2: "25px",
          margin: "10px 10px 10px 0",
          "border-radius": "10px",
        },
        ".top-slider .slider-content .slide-btn1": {
          "background-color": "rgb(255 73 124 / 100)",
        },
        ".top-slider .carousel-control-next-icon, .top-slider .carousel-control-prev-icon":
        {
          "background-color": "rgb(0 0 0 / 0)",
          "border-radius": "0px",
        },
      },
    });
    setSkill([{ id: randomStr(2), skill: "", parentageOfSkill: "" }]);
    setGalleryImgId("");
    setFormDataChild({
      image: "",
      title: "",
      description: "",
      isTitleShow: true,
      buttonCaption: "",
      imageAlt: "",
      buttonLink: "",
      order: 1,
      webId: localStorage.getItem("webId"),
      navMapId: "",
    });
    setLoaderShow(false);
    setSettingFormData({
      ".top-slider": {
        "background-color": "rgb(255 255 255 / 100)",
      },
      ".top-slider .carousel-item:before": {
        // "background-color": "rgb(0 0 0 / 0.8)",
      },
      // ".top-slider .slider-content": {
      //   padding: "200px 0",
      //   "max-width": "500px",
      // },
      ".top-slider .slider-content .slide-title": {
        color: "rgb(255 255 255 / 100)",
        "font-size": "40px",
        "font-weight": "600",
        "margin-bottom": "20px",
      },
      ".top-slider .slider-content .slide-desq": {
        color: "rgb(255 255 255 / 100)",
        "font-size": "16px",
        "font-weight": "500",
        "margin-bottom": "20px",
      },
      ".top-slider .slider-content .btn": {
        color: "rgb(255 255 255 / 100)",
        border: "2px solid rgb(255 73 124 / 100)",
        borderColor: "rgb(255 73 124 / 100)",
        "font-size": "16px",
        "font-weight": "600",
        padding: "8px 25px",
        p1: "8px",
        p2: "25px",
        margin: "10px 10px 10px 0",
        "border-radius": "10px",
      },
      ".top-slider .slider-content .slide-btn1": {
        "background-color": "rgb(255 73 124 / 100)",
      },
      ".top-slider .carousel-control-next-icon, .top-slider .carousel-control-prev-icon":
      {
        "background-color": "rgb(0 0 0 / 0)",
        "border-radius": "0px",
      },
      sliderId: "",
    });
  };

  const handleAlignAndCloneSection = ({ isClone = false }) => {
    if (isClone) {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          cloneModal: true,
        };
      });
      setCloneFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          pageConfigDetailsLabel: pageConfigDetails[0]?.label,
          contentDetailName: contentDetail.name,
        };
      });
    } else {
      setCloneAlignModal((prev) => {
        return {
          ...prev,
          alignModal: true,
        };
      });
      setAlignFormData((prev) => {
        return {
          ...prev,
          contentMapId,
          label: pageConfigDetails[0]?.label,
        };
      });
    }
  };
  return (
    <>
      <Col xl="12 box-col-6" md="12">
        <Card className="ecommerce-widget mt-4 cardHover">
          <CardBody
            className="support-ticket-font box-border-div"
            style={{ padding: "20px" }}
          >
            <Row>
              <CardBuilderHeaderSection
                addBtnTitle={pageConfigDetails[0]?.label}
                name={pageConfigDetails[0]?.label}
                isAdd={!sliderDetail && true}
                mainEditSection={true}
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
                openModal={() => {
                  OpenModalCommonFunc(
                    Cases.SLIDER_MULTIPAGE_PARENT,
                    setAllPopupState
                  );
                  setSectionPageName(modalsName.SLIDER_PARENT);
                  emptyData();
                  setIsParent(true);
                  setCollId(contentMapId);
                }}
                isCloneSection={true}
                isAlignSection={true}
                handleAlignAndCloneSection={handleAlignAndCloneSection}
              />
              {sliderDetail && (
                <Col xl="12 xl-50 box-col-6" md="6">
                  <Card className="ecommerce-widget mb-0">
                    <CardBody
                      className="support-ticket-font"
                      style={{ padding: "20px" }}
                    >
                      <div className="col-12">
                        <CardBuilderHeaderSection
                          name={sliderDetail?.title}
                          checked={sliderDetail?.isActive}
                          switchToggle={true}
                          id={sliderDetail?.sliderId}
                          handleChange={handleChangeSlider}
                        />
                        <OpenPopupBtn
                          openPopup={() => {
                            getSliderParentList({
                              parentId: sliderDetail.sliderId,
                            });
                            setSectionPageName(sliderDetail?.title);
                            setCollId(contentMapId);
                            setNavMapId(sliderDetail?.navMapId);
                            setFilter("");
                          }}
                          name={`Add or View ${sliderDetail?.title ?? ""}`}
                        />
                      </div>
                      <div className="d-flex justify-content-end ">
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            setCollId(contentMapId);
                            handleEditSlider(sliderDetail.sliderId, true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() =>
                            handleDelete(sliderDetail.sliderId, true)
                          }
                        >
                          <Trash />
                        </IconButton>
                        <IconButton
                          edge="start"
                          color="inherit"
                          style={{ marginLeft: "5px" }}
                          onClick={() => {
                            handleChangeSettings(sliderDetail.sliderId);
                          }}
                        >
                          <Settings />
                        </IconButton>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              )}
              <DeleteSection
                ByteMiniWeb_Dashboard={ByteMiniWeb_Dashboard}
                pageId={pageConfigDetails[0]?.pageId}
              />
            </Row>
          </CardBody>
        </Card>
      </Col>
      <CommonPopup
        open={allPopupState.sliderMultipageChildPopup}
        close={() => {
          OpenModalCommonFunc(Cases.SLIDER_MULTIPAGE, setAllPopupState, false);
          setIsParent(false);
        }}
        // apiCall={getSliderParentList}
        modalName={sectionPageName ? sectionPageName : modalsName.SLIDER}
        modalCase={Cases.SLIDER_MULTIPAGE}
        handleSubmit={handleSubmit}
        validationForm={"childForm"}
        emptyData={emptyData}
        inputData={fromData}
        edit={false}
        oldTitle={titleUpdateKey.isGallery}
        label={titleUpdateKey.Certificates}
        getData={getData}
        content={
          <SliderPopup
            handleChangeStatus={handleChangeSlider}
            getSliderParentList={getSliderParentList}
            handleEdit={handleEditSlider}
            imageUpload={imageUploadImages}
            emptyData={emptyData}
            simpleValidator={childValidator}
            webMasterDetail={webMasterDetail}
            handleDelete={handleDelete}
          />
        }
      />

      {/* slider popup */}
      <CommonPopup
        open={allPopupState.sliderMultipagePopup}
        close={() => {
          OpenModalCommonFunc(
            Cases.SLIDER_MULTIPAGE_PARENT,
            setAllPopupState,
            false
          );
          setIsParent(false);
        }}
        modalName={sectionPageName ? sectionPageName : modalsName.SLIDER_PARENT}
        modalCase={Cases.SLIDER_MULTIPAGE_PARENT}
        handleSubmit={handleSubmit}
        validationForm={"parentForm"}
        emptyData={emptyData}
        inputData={formDataChild}
        edit={false}
        content={<SliderParentPopup simpleValidator={parentValidator} />}
      />

      {/* setting Service Counter parent popup */}
      <CommonPopup
        open={allPopupState.sliderSettingPopup}
        close={() =>
          OpenModalCommonFunc(
            Cases.SETTING_SLIDER_PARENT,
            setAllPopupState,
            false
          )
        }
        modalName={
          sectionPageName ? sectionPageName : modalsName.SETTING_SLIDER_PARENT
        }
        modalCase={Cases.SETTING_SLIDER_PARENT}
        handleSubmit={handleSubmitSetting}
        emptyData={emptyData}
        inputData={formDataChild}
        edit={false}
        content={
          <SettingSliderPerentPopup
            handleChangeSettings={handleChangeSettings}
            handleSubmitSetting={handleSubmitSetting}
          />
        }
      />
    </>
  );
};

export default SliderMultipage;
